import { createH5Platform } from '../platform/h5';
import { App } from '../core/game';

const canvas = document.getElementById('game') as HTMLCanvasElement;
if (!canvas) throw new Error('missing #game canvas');
const platform = createH5Platform(canvas);
new App(platform);
